<template>
  <div class="customReport">
    <div v-if="this.$route.path=='/report/reporttool/customReport'">
      <div class="page-title">定制报表</div>
      <!-- 表单查询 -->
      <el-form label-width="100px" class="query-form" :model="queryForm" :inline="true">
        <div>
          <el-form-item label="报表名称">
            <el-input v-model="queryForm.reportName" @blur="customTemplateList"></el-input>
          </el-form-item>
          <el-form-item label="数据源名称">
            <el-select @change="customTemplateList" v-model="queryForm.agentAccountIdList" multiple collapse-tags filterable clearable placeholder="请选择" style="width: 300px">
              <el-option
                v-for="item in timeOptions"
                :key="item.agentAccountId"
                :label="item.agentAccountName"
                :value="item.agentAccountId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button v-permission="'customReport:addCustomTempalteContent'" @click="$router.push({path: '/report/reporttool/customReport/addCustomReport'})" class="fr" type="primary" size="medium" icon="iconfont icon-tianjia-copy">新建报表模板</el-button>
        </div>
      </el-form>
      <!-- 表格 -->
      <el-table class="center-table roleTable"
        :data="tableData" v-loading="tableLoading"
        border style="width: 100%">
        <el-table-column
          prop="reportName"
          label="报表名称">
          <template slot-scope="scope">
            <el-link type="primary"
            @click="$router.push({path: '/report/reporttool/customReport/customReportDetails', query: {'id': scope.row.id, 'name':scope.row.reportName, 'keywordExtractType':scope.row.keywordExtractType}})">
            {{scope.row.reportName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="agentAccountNames"
          label="数据源名称">
          <template slot-scope="scope">
            <el-popover
              placement="left"
              width="320"
              trigger="hover"
              :content="scope.row.agentAccountNames">
              <span class="copy" slot="reference" >{{scope.row.agentAccountNames}}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="模板状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="changeStatus($event,scope.row)" :active-value="1" :inactive-value="0"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission('customReport:addCustomTempalteContent') || checkPermission('customReport:downloadCustomReportsTemplate')"
          prop="operation"
          label="操作">
          <template slot-scope="scope">
            <el-button v-permission="'customReport:addCustomTempalteContent'"
            @click="$router.push({path: '/report/reporttool/customReport/editCustomReport',query: {'name': scope.row.reportName, 'id': scope.row.id}})"
            type="text">编辑</el-button>
            <el-button v-permission="'customReport:downloadCustomReportsTemplate'" @click="downloadExcel(scope.row.id)" type="text">下载模板</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging-box" v-if="pageTotal > 0">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="queryForm.pageNum"
          :page-sizes="[10, 20, 40, 80, 100]"
          @size-change="handleSizeChange"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>

export default {
  name: 'customReport',
  data () {
    return {
      tableLoading: true,
      // 查询表单
      queryForm: {
        reportName: '',
        agentAccountIdList: [],
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 选择数据源名称
      timeOptions: [],
      // 表格数据
      tableData: []
    }
  },
  created () {
    if (this.$route.path === '/report/reporttool/customReport') {
      this.customTemplateList()
      this.getAccountList4Select()
    }
  },
  methods: {
    // 切换分页
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.customTemplateList()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.customTemplateList()
    },
    // 下载模板
    downloadExcel (id) {
      // 创建a标签下载
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$instance.defaults.baseURL + '/api/customReport/downloadCustomReportsTemplate?templateId=' + id
      link.setAttribute('download', '规范')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    // 获取查询数据
    customTemplateList () {
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/customReport/customTemplateList', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.tableData = res.result.pageData
          this.pageTotal = res.result.total
        }
      }).catch(Err => {})
    },
    // 数据源下拉框
    getAccountList4Select () {
      this.$service.post('/api/project/getAccountList4Select').then(res => {
        if (res.code === 200) {
          this.timeOptions = res.result
        }
      }).catch(Err => {})
    },
    // 状态开关
    changeStatus (event, item) {
      item.status = item.status === 0 ? 1 : 0
      let tipStr = ''
      if (item.status === 1) {
        tipStr = '报表停用后将不再更新数据确认停用吗?'
      } else {
        tipStr = '确认开启报表模板吗'
      }
      this.$confirm(tipStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let status = item.status === 0 ? 1 : 0
        this.$service.post('/api/customReport/updateCustomReportsStatus', {'templateId': item.id, 'status': status}).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            item.status = item.status === 0 ? 1 : 0
          }
        }).catch(Err => {})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  },
  watch: {
    // 监测弹窗
    $route (to) {
      if (to.path === '/report/reporttool/customReport') {
        this.customTemplateList()
        this.getAccountList4Select()
      }
    }
  },
  computed: {
  }
}
</script>

<style lang="less">
  @import './../../styles/report/customReport.less';
  .customReport {
    .query-form{
      margin-bottom: -21px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/customReport.vue